import { useState } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import SignUpForm from '../7bs/SignUpForm'

const IndexHeader = (props) => {

    const [lgShow, setLgShow] = useState(false);

return(
    <>
    <div className="section-index-header">
        <Container>
            <Row className="align-items-end">
                <Col xl={7} lg={7} md={9} className="py-5">
                    <h2>SPECIAL REPORT REVEALS</h2>
                    <Image src="../images/7bs/bg-ruler-top01.png" alt="" className="img-fluid"/>
                    <h1>THE 7 BIG SECRETS<br/>
                        TO LOSING WEIGHT</h1>
                    <Image src="../images/7bs/bg-ruler-bottom01.png" alt="" className="img-fluid mb-3"/>
                    <p>Discover how some of Hollywood's biggest stars get in shape and look their best within weeks.</p>
                    <p>We'll reveal the tips and techniques of one of America's most sought-after diet and fitness experts.</p>
                    <h3 className="text-center">Fill in the form to get the special report for free!</h3>
                    <p><a className="btn btn-free-report" onClick={() => setLgShow(true)}>Give me the FREE Report!</a></p>
                </Col>
                <Col xl={5} lg={5} md={3} className="d-none d-md-block">
                    <Image src="../images/7bs/bg-happy-lady01.png" alt="7 Big Secrets To Losing Weight 6" className="img-fluid w-100"/>
                </Col>
            </Row>
        </Container>
    </div>
    <SignUpForm show={lgShow} onHide={() => setLgShow(false)} global={props.global}/>
    <style jsx global>{`

            .section-index-header {
                background: url(../images/7bs/bg-orange-stairs01.jpg) no-repeat center top;
                background-size: cover;
                border-bottom: 10px solid #494949;
                color: #fff;
            }

            .section-index-header h2 {
                font-family: 'Roboto', Helvetica, Arial, sans-serif;
                font-size: 40px;
                font-weight: 300;
                margin: 0;
            }

            .section-index-header h1 {
                font-family: 'Bebas Neue', Helvetica, Arial, sans-serif;
                font-size: 44px;
                font-weight: 900;
                margin: 0;
            }

            .section-index-header p {
                font-family: 'Roboto', Helvetica, Arial, sans-serif;
                font-weight: 300;
                font-size: 18px;
            }

            .section-index-header h3 {
                font-family: 'Roboto', Helvetica, Arial, sans-serif;
                font-weight: 700;
            }

            .section-index-header form {
                background: #52c4d2;
                padding: 15px;
                border-radius: 5px;
            }

        `}</style>
    </>
);
}

export default IndexHeader;